import { ComponentAPI } from '@philips-emr/tws-core';

import { LayoutAlign, LayoutGap, LayoutJustify  } from './constants';

class LayoutAPI extends ComponentAPI {

  getRows(): string {
    return this.state.rows;
  }

  setRows(rows: string): void {
    this.setState({ rows });
  }

  getColumns(): string {
    return this.state.columns;
  }

  setColumns(columns: string): void {
    this.setState({ columns });
  }

  getRowGap(): LayoutGap {
    return this.state.rowGap;
  }

  setRowGap(rowGap: LayoutGap): void {
    this.setState({ rowGap });
  }

  getColumnGap(): LayoutGap {
    return this.state.columnGap;
  }

  setColumnGap(columnGap: LayoutGap): void {
    this.setState({ columnGap });
  }

  getAlignItems(): LayoutAlign {
    return this.state.alignItems;
  }

  setAlignItems(alignItems: LayoutAlign): void {
    this.setState({ alignItems });
  }

  getJustifyItems(): LayoutJustify {
    return this.state.justifyItems;
  }

  setJustifyItems(justifyItems: LayoutJustify): void {
    this.setState({ justifyItems });
  }

  getLayoutAlign(): LayoutAlign {
    return this.state.alignContent;
  }

  setLayoutAlign(alignContent: LayoutAlign): void {
    this.setState({ alignContent });
  }

  getJustifyContent(): LayoutJustify {
    return this.state.alignContent;
  }

  setJustifyContent(justifyContent: LayoutJustify): void {
    this.setState({ justifyContent });
  }

  getTemplateAreas(): string {
    return this.state.templateAreas;
  }

  setTemplateAreas(templateAreas: string): void {
    this.setState({ templateAreas });
  }

}

export default LayoutAPI;
